import React from 'react';
import { Progress } from './ui/progress';
import { CheckCircle2 } from 'lucide-react';

const ProgressBar = ({ label, percentage }) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </span>
        <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1">
          {percentage === 100 && <CheckCircle2 className="h-4 w-4 text-green-500" />}
          {percentage}%
        </span>
      </div>
      <Progress value={percentage} className="h-2" />
    </div>
  );
};

export default ProgressBar;